// Layout

const isMobile = () => {
  return window.innerWidth < 769;
}

// Section parallax

const isScrolledIntoView = (el) => {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;
  var indentH = 200;
  if(window.innerWidth <= 768) {
    indentH = 100;
  }
  isVisible = elemTop < (window.innerHeight - indentH) && elemBottom >= indentH;
  return isVisible;
}

const initParallax = () => {
  document.querySelectorAll('.parallax-block').forEach((block, idx) => {
    if(isScrolledIntoView(block)) {
      block.classList.add('visible');
    }
    else {
      block.classList.remove('visible');
    }
  })
}

// Section media slider

const initMediaSlider = () => {
  const carousel = document.querySelectorAll('.media-carousel');
  carousel.forEach((carousel) => {

    const desktopDots = carousel.querySelector('.custom-carousel-dots.mobile--hidden');
    const mobileDots = carousel.querySelector('.custom-carousel-dots.desktop--hidden');

    let itemsPerRow = parseInt(carousel.dataset.itemsPerRow);
    let carouselDots = desktopDots.querySelectorAll('span');

    if(isMobile()) {
      carouselDots = mobileDots.querySelectorAll('span');
      itemsPerRow = 1;
    }

    carouselDots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();

        const index = dot.dataset.index;
        let activeDot = desktopDots.querySelector('span.active');

        if(isMobile()) {
          activeDot = mobileDots.querySelector('span.active');
        }

        activeDot.classList.remove('active');
        dot.classList.add('active');
        carousel.querySelectorAll('.carousel-cell').forEach((cell) => {
          let cellIdx = parseInt(cell.dataset.index);
          if(cellIdx > (index - 1) * itemsPerRow && cellIdx <= index * itemsPerRow) {
            cell.classList.add('active');
          }
          else {
            cell.classList.remove('active');
          }
        })
      })
    })
    
    carouselDots[0].click();

    var touchstartX = 0;
    var touchendX = 0;
    var is_clicked = false;
    var is_sliding = false;

    const autoScrollInit = setInterval( function() {
      is_sliding = true;
      let autoTarget = null;
      autoTarget = desktopDots.querySelector('span.active').nextElementSibling;
        if(isMobile()) {
          autoTarget = mobileDots.querySelector('span.active').nextElementSibling;  
        }
      // reach the end loop back to beginnning
      if (!autoTarget) {
        autoTarget = desktopDots.querySelectorAll('span')[0];
        if(isMobile()) {
          autoTarget = mobileDots.querySelectorAll('span')[0];
        }
      }
      autoTarget.click();
        setTimeout(() => {
          is_sliding = false;
          is_clicked = false;
        }, 300);
    }, 3000);

    if(isMobile()) {
      carousel.addEventListener('touchstart', (e) => {
        clearInterval(autoScrollInit);
        touchstartX = e.touches[0].pageX;
        if(!is_sliding) {
          is_clicked = true
        }
      })

      carousel.addEventListener('touchmove', (e) => {
        clearInterval(autoScrollInit);
        touchendX = e.touches[0].pageX;
      })

      carousel.addEventListener('touchend', (e) => {
        clearInterval(autoScrollInit);
        if(is_clicked && !is_sliding) {
          swipeCarousel(touchstartX, touchendX);
        }
      })
    }
    else {
      carousel.addEventListener('mousedown', (e) => {
        clearInterval(autoScrollInit);
        touchstartX = e.pageX;
        if(!is_sliding && !e.target.closest('.custom-carousel-dots')) {
          is_clicked = true
        }
      })
      carousel.addEventListener('mousemove', (e) => {
        clearInterval(autoScrollInit);
        touchendX = e.pageX;
        if(is_clicked && !is_sliding) {
          swipeCarousel(touchstartX, touchendX);
        }
      })
    }
    
    function swipeCarousel(startX, endX) {
      is_sliding = true;
      let target = null;
      if(endX > startX) {
        target = desktopDots.querySelector('span.active').previousElementSibling;
        if(isMobile()) {
          target = mobileDots.querySelector('span.active').previousElementSibling;
        }
      }
      else {
        target = desktopDots.querySelector('span.active').nextElementSibling;
        if(isMobile()) {
          target = mobileDots.querySelector('span.active').nextElementSibling;  
        }
      }
      if(target) {
        target.click();
        setTimeout(() => {
          is_sliding = false;
          is_clicked = false;
        }, 300);
      }
      else {
        is_sliding = false;
        is_clicked = false;
      }
    }

  })
}

window.addEventListener('DOMContentLoaded', () => {
  initParallax();
  initMediaSlider();
})

window.addEventListener('scroll', () => {
  initParallax();
})